//  @/store/modules/opportunities.js
import Vue from 'vue'

const state = {   
    headers: [
      {
        text: 'Représentant',
        value: 'author',
      },
      {
        text: 'Client',
        value: 'client',
      },
      {
        text: 'Description',
        value: 'desc',
      },
      {
        text: 'Grilles de calcul créées',
        value: 'calcs',
      },
    ],
    calcHeaders: [
      {
        text: 'Identifiant',
        value: 'id',
      },
      {
        text: 'Appareil',
        value: 'mainframe',
      },
      {
        text: 'Prix',
        value: 'price',
      },
      {
        text: 'Mises-à-jour',
        value: 'updates',
      },
      {
        text: 'Dernière mise-à-jour',
        value: 'lastUpdate',
      },
    ],
    items: [],
  }
  
  const mutations = {
    SET_ITEM (state, doc) {
      const data = doc.data()
      state.items = {
        ...state.items, 
        [doc.id]: data
      }
    },
    UPDATE_ITEM (state, doc) {
      state.items[doc.id] = doc.data()
    },
    DELETE_ITEM (state, doc) {
      Vue.delete(state.items, doc.id)
    },
  }

  const getters = {}
  
  const actions = {
    async init({ commit, rootState, dispatch }) {
      rootState.db.collection('opportunities').onSnapshot(snapshot => {
        let changes = snapshot.docChanges()
        changes.forEach(change => {
          let type = change.type
          let doc = change.doc
          
          if(type === 'added' && (doc.data().author === rootState.auth.user.id || Boolean(rootState.auth.user.admin))) commit('SET_ITEM', doc)
          else if(type === 'modified') commit('UPDATE_ITEM', doc)
          else if(type === 'removed') commit('DELETE_ITEM', doc)
        })
      }, (error) => {console.log(error.message)})
    },
    async add({ rootState, commit, dispatch }, data) {
      let update = {
        time: new Date().toISOString(),
        user: rootState.auth.user.id,
        action: 'created',
      }

      data.updates = [ update ]

      let response = await rootState.db.collection('opportunities').add(data)
      return response
    },
    async set({ rootState }, data) {
      let update = {
        time: new Date().toISOString(),
        user: rootState.auth.user.id,
        action: 'updated',
      }

      data[1].updates = [ ...data[1].updates, update ]

      let ref = rootState.db.collection('opportunities').doc(data[0])
      let response = await ref.set(data[1])
      return response
    },
    async delete({ rootState }, id) {
      let response = await rootState.db.collection('opportunities').doc(id).delete()
      return response
    },
    async close({ rootState }) { 
      let response = await rootState.db.collection('opportunities').onSnapshot(() => {})
      return response
    },
  }
  
  export default { 
    namespaced: true, state, mutations, getters, actions
  }